/**
 * Utility for handling admin impersonation tokens
 */

const IMPERSONATION_TOKEN_KEY = "impersonationToken";

/**
 * Gets the impersonation token from localStorage
 */
export const getImpersonationToken = (): string | null => {
  if (typeof window === "undefined") {
    return null;
  }
  return localStorage.getItem(IMPERSONATION_TOKEN_KEY);
};

/**
 * Sets the impersonation token in localStorage
 */
export const setImpersonationToken = (token: string): void => {
  if (typeof window === "undefined") {
    return;
  }
  localStorage.setItem(IMPERSONATION_TOKEN_KEY, token);
};

/**
 * Removes the impersonation token from localStorage
 */
export const clearImpersonationToken = (): void => {
  if (typeof window === "undefined") {
    return;
  }
  localStorage.removeItem(IMPERSONATION_TOKEN_KEY);
};

/**
 * Checks if currently in impersonation mode
 */
export const isImpersonating = (): boolean => !!getImpersonationToken();

/**
 * Extracts impersonation token from URL query parameters
 * and saves it to localStorage if found
 */
export const handleImpersonationTokenFromUrl = (): void => {
  if (typeof window === "undefined") {
    return;
  }

  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get("impersonationToken");

  if (token) {
    setImpersonationToken(token);

    // Remove token from URL for security/cleanliness
    const newUrl = new URL(window.location.href);
    newUrl.searchParams.delete("impersonationToken");
    window.history.replaceState({}, "", newUrl.toString());
  }
};
